export const API_URL = process.env.REACT_APP_API_URL || 'https://api-lp1.spores.dev/v1/tickets';
export const BASE_API_URL = process.env.REACT_APP_BASE_API_URL || 'https://api-lp1.spores.dev/v1';
export const BOOMI_START_TIME = '2022-01-12T12:00:00.000Z';
export const BOOMI_END_TIME = '2022-01-14T12:00:00.000Z';
export const ADDRESS_RECEIVER = process.env.REACT_APP_ADDRESS_RECEIVER || '0x063E6329BDeA016e110dcBCA76A24c0F50b13e38';
export const NETWORK_CHAIN_IDS = process.env.REACT_APP_NETWORK_CHAIN_IDS || '0x61';
